import { createBrowserRouter } from "react-router-dom";
import { Root } from "~/Root";
import { Home } from "~/routes/Home";
import { Play } from "~/routes/Play";
import { Augment } from "~/routes/Augment";
import { Mobile } from "~/routes/Mobile";
import { ReactNative } from "~/routes/ReactNative";
import { AI } from "~/routes/AI";
import { Trade } from "~/routes/Trade";
import { Build } from "~/routes/Build";
import { Engine } from "~/routes/Engine";
import { Hire } from "~/routes/Hire";
import { NotFound } from "~/routes/NotFound";
import { Tutorial } from "~/routes/Tutorial";
import { TutorialCabecudo } from "~/routes/TutorialCabecudo";
import { Privacidade } from "~/routes/Privacidade";
import { IAHub } from "~/routes/IAHub";
import { IAAssunto } from "~/routes/IAAssunto";
import {
  ListaConfirmada,
  ListaLinkExpirado,
  ListaLinkInvalido,
  ListaSaiu,
} from "~/routes/Lista";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      { index: true, element: <Home /> },
      { path: "play", element: <Play /> },
      { path: "augment", element: <Augment /> },
      { path: "mobile", element: <Mobile /> },
      { path: "react-native", element: <ReactNative /> },
      { path: "ai", element: <AI /> },
      { path: "trade", element: <Trade /> },
      { path: "build", element: <Build /> },
      { path: "engine", element: <Engine /> },
      { path: "hire", element: <Hire /> },
      { path: "tutorial", element: <Tutorial /> },
      { path: "tutorial/cabecudo", element: <TutorialCabecudo /> },
      // As paginas de assunto: o que a busca encontra.
      { path: "ia", element: <IAHub /> },
      { path: "ia/:assunto", element: <IAAssunto /> },
      { path: "privacidade", element: <Privacidade /> },
      // Onde o servidor larga quem clicou no link do e-mail.
      { path: "lista/confirmada", element: <ListaConfirmada /> },
      { path: "lista/saiu", element: <ListaSaiu /> },
      { path: "lista/link-expirado", element: <ListaLinkExpirado /> },
      { path: "lista/link-invalido", element: <ListaLinkInvalido /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
